import { render, staticRenderFns } from "./AutoRebalancePromoModal.vue?vue&type=template&id=0b144a9a&scoped=true"
import script from "./AutoRebalancePromoModal.vue?vue&type=script&lang=js"
export * from "./AutoRebalancePromoModal.vue?vue&type=script&lang=js"
import style0 from "./AutoRebalancePromoModal.vue?vue&type=style&index=0&id=0b144a9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b144a9a",
  null
  
)

export default component.exports